<div class="actions-container">
    <ol *ngIf="parentId">
        <li class="relative flex py-7" *ngFor="let item of data">
            <div class="absolute left-5 top-7 -ml-px h-full w-0.5 bg-gray-300 dark:bg-gray-600"></div>
            <div class="relative flex flex-auto">
                <!-- Order and Title -->
                <div class="mr-4 flex h-10 w-10 shrink-0 items-center justify-center rounded-full bg-gray-100 border-solid border-gray-300 border-2"
                    [class.editing]="editingId == item._id">
                    <span class="font-medium text-xl" [hidden]="editingId == item._id">{{item[orderField]}}</span>
                    <kendo-numerictextbox [hidden]="editingId != item._id" [(ngModel)]="item[orderField]"
                        [width]="'100%'" class="order-textbox" [spinners]="false" size="none" format="##">
                    </kendo-numerictextbox>
                </div>

                <div class="flex flex-auto flex-col items-start p-2 rounded-lg bg-gray-100 border-solid border-gray-300 border-2"
                    [class.editing]="editingId == item._id">
                    
                    <div class="mt-1 overflow-hidden w-full px-2 py-1 field-container">
                        <span class="font-medium" >{{'timeline.title' |transloco}}: </span>
                        <kendo-textbox [disabled]="editingId != item._id" [(ngModel)]="item[titleField]"
                            [width]="'100%'"></kendo-textbox>
                    </div>

                    <!-- Description -->
                    <div class="mt-1 overflow-hidden w-full px-2 py-1 field-container">
                        <span class="font-medium" >{{'timeline.description' |transloco}}: </span>
                        <kendo-textarea [disabled]="editingId != item._id" [width]="'100%'"
                            [(ngModel)]="item[descriptionField]"></kendo-textarea>
                    </div>



                    <div class="drake-field-wrapper" *ngFor="let field of viewConfig.viewFields">
                        <app-drake-field
                          *ngIf="checkFieldInExtraFields(field)"  
                          [fieldConfig]="field"
                          [baseData]="item"
                          [readonly]="editingId != item._id"
                          (valueChanged)="valueChanged($event)"
                        ></app-drake-field>
                    </div>






                    
                    
                    <!-- Images Gallery (Display under description) -->
                    <div class="mt-2 w-full flex flex-wrap">
                        <div class="gallery-item relative" *ngFor="let image of item[galleryField]; let i = index">
                            <!-- Image display -->
                            <img [src]="image.ImageDataUrl" alt="Gallery Image" class="object-cover w-48 h-24 rounded-lg">
                            
                            <!-- Image description: editable during edit mode -->
                            <span class="text-sm" [hidden]="editingId == null">{{image.ImageDescription}}</span>
                            <kendo-textbox [(ngModel)]="image.ImageDescription" *ngIf="editingId == item._id" [width]="'200px'" class="img-description">
                            </kendo-textbox>

                            <!-- Delete (X) button - only visible in edit mode -->
                            <button type="button" *ngIf="editingId == item._id" class="delete-image-btn" (click)="removeImage(item, i)">
                                <mat-icon>close</mat-icon>
                            </button>
                        </div>
                        <button type="button" (click)="openFileManager(item)" class="add-button" kendoButton [svgIcon]="newSVG" *ngIf="editingId == item._id"></button>
                    </div>

                </div>

                <!-- Edit, Save, Cancel Buttons -->
                <div *ngIf="!readonly" class="mx-4 flex h-10 w-10 shrink-0 items-center justify-center rounded-full bg-gray-100 border-solid border-gray-300 border-2">
                    <button type="button" (click)="editElement(item)" kendoButton [hidden]="editingId == item._id"
                        [disabled]="editingId" [svgIcon]="editSVG" class="rounded-full">
                    </button>
                    <button type="button" (click)="saveElement(item)" kendoButton [hidden]="editingId != item._id"
                        [svgIcon]="saveSVG" class="rounded-full">
                    </button>
                </div>

                <div *ngIf="!readonly"
                    class="flex h-10 w-10 shrink-0 items-center justify-center rounded-full bg-gray-100 border-solid border-gray-300 border-2">
                    <button type="button" (click)="cancelEditElement()" kendoButton [hidden]="editingId != item._id"
                        [svgIcon]="cancelSVG" class="rounded-full">
                    </button>
                    <button type="button" (click)="deleteElement(item)" kendoButton [hidden]="editingId"
                        [svgIcon]="deleteSVG" class="rounded-full">
                    </button>
                </div>
            </div>
        </li>

        <!-- Add Element Button -->
        <li class="relative flex py-7">
            <div class="relative flex flex-auto">
                <div class="mr-4 flex h-10 w-10 shrink-0 items-center justify-center rounded-full bg-gray-100 border-solid border-gray-300 border-2">
                    <button type="button" (click)="addElement()" kendoButton [disabled]="editingId || !parentId" *ngIf="!readonly"
                        [svgIcon]="newSVG" class="rounded-full">
                    </button>
                    <button type="button" kendoButton [disabled]="true" *ngIf="readonly"
                        [svgIcon]="endSVG" class="rounded-full">
                    </button>
                </div>
                <div class="flex flex-auto flex-col items-start"></div>
            </div>
        </li>
    </ol>

    <div *ngIf="!parentId">
        <fuse-alert [type]="'warning'">
            <span fuseAlertTitle>{{'common.mustSaveTitle' | transloco}}</span>
            {{(readonly ? 'common.mustSelectDescription' : 'common.mustSaveDescription') | transloco}}
        </fuse-alert>
    </div>
</div>
